export const COUNTRY_CODES = {
  afg: 'af',
  alb: 'al',
  dza: 'dz',
  asm: 'as',
  and: 'ad',
  ago: 'ao',
  aia: 'ai',
  ata: 'aq',
  atg: 'ag',
  arg: 'ar',
  arm: 'am',
  abw: 'aw',
  aus: 'au',
  aut: 'at',
  aze: 'az',
  bhs: 'bs',
  bhr: 'bh',
  bgd: 'bd',
  brb: 'bb',
  blr: 'by',
  bel: 'be',
  blz: 'bz',
  ben: 'bj',
  bmu: 'bm',
  btn: 'bt',
  bol: 'bo',
  bes: 'bq',
  bih: 'ba',
  bwa: 'bw',
  bvt: 'bv',
  bra: 'br',
  iot: 'io',
  brn: 'bn',
  bgr: 'bg',
  bfa: 'bf',
  bdi: 'bi',
  cpv: 'cv',
  khm: 'kh',
  cmr: 'cm',
  can: 'ca',
  cym: 'ky',
  caf: 'cf',
  tcd: 'td',
  chl: 'cl',
  chn: 'cn',
  cxr: 'cx',
  cck: 'cc',
  col: 'co',
  com: 'km',
  cod: 'cd',
  cog: 'cg',
  cok: 'ck',
  cri: 'cr',
  hrv: 'hr',
  cub: 'cu',
  cuw: 'cw',
  cyp: 'cy',
  cze: 'cz',
  civ: 'ci',
  dnk: 'dk',
  dji: 'dj',
  dma: 'dm',
  dom: 'do',
  ecu: 'ec',
  egy: 'eg',
  slv: 'sv',
  gnq: 'gq',
  eri: 'er',
  est: 'ee',
  swz: 'sz',
  eth: 'et',
  flk: 'fk',
  fro: 'fo',
  fji: 'fj',
  fin: 'fi',
  fra: 'fr',
  guf: 'gf',
  pyf: 'pf',
  atf: 'tf',
  gab: 'ga',
  gmb: 'gm',
  geo: 'ge',
  deu: 'de',
  gha: 'gh',
  gib: 'gi',
  grc: 'gr',
  grl: 'gl',
  grd: 'gd',
  glp: 'gp',
  gum: 'gu',
  gtm: 'gt',
  ggy: 'gg',
  gin: 'gn',
  gnb: 'gw',
  guy: 'gy',
  hti: 'ht',
  hmd: 'hm',
  vat: 'va',
  hnd: 'hn',
  hkg: 'hk',
  hun: 'hu',
  isl: 'is',
  ind: 'in',
  idn: 'id',
  irn: 'ir',
  irq: 'iq',
  irl: 'ie',
  imn: 'im',
  isr: 'il',
  ita: 'it',
  jam: 'jm',
  jpn: 'jp',
  jey: 'je',
  jor: 'jo',
  kaz: 'kz',
  ken: 'ke',
  kir: 'ki',
  prk: 'kp',
  kor: 'kr',
  kwt: 'kw',
  kgz: 'kg',
  lao: 'la',
  lva: 'lv',
  lbn: 'lb',
  lso: 'ls',
  lbr: 'lr',
  lby: 'ly',
  lie: 'li',
  ltu: 'lt',
  lux: 'lu',
  mac: 'mo',
  mdg: 'mg',
  mwi: 'mw',
  mys: 'my',
  mdv: 'mv',
  mli: 'ml',
  mlt: 'mt',
  mhl: 'mh',
  mtq: 'mq',
  mrt: 'mr',
  mus: 'mu',
  myt: 'yt',
  mex: 'mx',
  fsm: 'fm',
  mda: 'md',
  mco: 'mc',
  mng: 'mn',
  mne: 'me',
  msr: 'ms',
  mar: 'ma',
  moz: 'mz',
  mmr: 'mm',
  nam: 'na',
  nru: 'nr',
  npl: 'np',
  nld: 'nl',
  ncl: 'nc',
  nzl: 'nz',
  nic: 'ni',
  ner: 'ne',
  nga: 'ng',
  niu: 'nu',
  nfk: 'nf',
  mnp: 'mp',
  nor: 'no',
  omn: 'om',
  pak: 'pk',
  plw: 'pw',
  pse: 'ps',
  pan: 'pa',
  png: 'pg',
  pry: 'py',
  per: 'pe',
  phl: 'ph',
  pcn: 'pn',
  pol: 'pl',
  prt: 'pt',
  pri: 'pr',
  qat: 'qa',
  mkd: 'mk',
  rou: 'ro',
  rus: 'ru',
  rwa: 'rw',
  reu: 're',
  blm: 'bl',
  shn: 'sh',
  kna: 'kn',
  lca: 'lc',
  maf: 'mf',
  spm: 'pm',
  vct: 'vc',
  wsm: 'ws',
  smr: 'sm',
  stp: 'st',
  sau: 'sa',
  sen: 'sn',
  srb: 'rs',
  syc: 'sc',
  sle: 'sl',
  sgp: 'sg',
  sxm: 'sx',
  svk: 'sk',
  svn: 'si',
  slb: 'sb',
  som: 'so',
  zaf: 'za',
  sgs: 'gs',
  ssd: 'ss',
  esp: 'es',
  lka: 'lk',
  sdn: 'sd',
  sur: 'sr',
  sjm: 'sj',
  swe: 'se',
  che: 'ch',
  syr: 'sy',
  twn: 'tw',
  tjk: 'tj',
  tza: 'tz',
  tha: 'th',
  tls: 'tl',
  tgo: 'tg',
  tkl: 'tk',
  ton: 'to',
  tto: 'tt',
  tun: 'tn',
  tur: 'tr',
  tkm: 'tm',
  tca: 'tc',
  tuv: 'tv',
  uga: 'ug',
  ukr: 'ua',
  are: 'ae',
  gbr: 'gb',
  umi: 'um',
  usa: 'us',
  ury: 'uy',
  uzb: 'uz',
  vut: 'vu',
  ven: 've',
  vnm: 'vn',
  vgb: 'vg',
  vir: 'vi',
  wlf: 'wf',
  esh: 'eh',
  yem: 'ye',
  zmb: 'zm',
  zwe: 'zw',
  ala: 'ax',
} as const;
